import { render, staticRenderFns } from "./SetBetUser.vue?vue&type=template&id=5ea22a3c&scoped=true&"
import script from "./SetBetUser.vue?vue&type=script&lang=js&"
export * from "./SetBetUser.vue?vue&type=script&lang=js&"
import style0 from "./SetBetUser.vue?vue&type=style&index=0&id=5ea22a3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea22a3c",
  null
  
)

export default component.exports